import React from 'react';

function Spinner(props) {
    const size = props.size ? 'spinner--' + props.size : '';
    return (
      <div className={'spinner ' + size}>
        { props.text && <div className="spinner__text">{ props.text}</div> }
      </div>
    );
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js